import { createContext } from "react";
import { IPerfectScrollContext } from "./perfectScrollModel";

export const PerfectScrollContext = createContext<IPerfectScrollContext>(null);
